import { mapKeys } from 'lodash-es';

export const PICTURE_REQUIRED = 'Required';
export const PICTURE_NOT_REQUIRED = 'NotRequired';

export const IS_PICTURE_REQUIRED = mapKeys(
  [{ id: PICTURE_REQUIRED, value: true }, { id: PICTURE_NOT_REQUIRED, value: false }],
  'id',
);
